import { useState } from "react"
import "./styles.css"
import "../../fonts.css"
import { IoIosSearch } from "react-icons/io"
import Mock from "./Mock"
import Info from "./Info"

import Loader from "../../components/Loader"
import { BiErrorCircle } from "react-icons/bi"
import usePlaces from "../../utils/mocks/places/usePlaces"
import Layout from "../../components/Layout"

const LocaisSugeridos = () => {
  const { data, loading, error } = usePlaces()
  const [search, setSearch] = useState("")

  return (
    <Layout
      title="Locais"
      titleColor="#6184FE"
      description=""
      hasBackground={false}
      children={
        <div className="container">
          <div className="search-container">
            <input
              placeholder="Busca"
              type="text"
              className="search-field"
              onChange={(event) => setSearch(event.target.value)}
            />
            <IoIosSearch color="rgba(0, 0, 0, 0.8)" />
          </div>
          <div className="containerLocais">
            {loading ? (
              <div className="item-error-locais">
                <Loader size={40} />
              </div>
            ) : data ? (
              data
                .filter((localData) => {
                  return search.toLocaleLowerCase() === ""
                    ? localData
                    : localData.name
                        .toLocaleLowerCase()
                        .includes(search.toLocaleLowerCase())
                })
                .map((localData) => {
                  return (
                    <Info
                      key={localData.id}
                      nomeLocal={localData.name}
                      endereco={localData.address}
                      imagemURL={localData.image_link}
                    />
                  )
                })
            ) : null}
            {error ? (
              <div className="item-error-locais">
                <BiErrorCircle /> Houve um erro ao processar sua solicitação.
              </div>
            ) : null}
          </div>
        </div>
      }
      backButton="/sugestoes"
    />
  )
}

export default LocaisSugeridos
